export default __webpack_public_path__ + "static/media/american-express.54738d89.svg";